import darkThemeColors from '@prisjakt/design-tokens/dark-theme-colors.json';
import { ThemeType } from './default';
import { setRgbaAlpha } from '../../src/color-utils';

const darkTheme: ThemeType = {
  colors: {
    ...darkThemeColors,
  },
  bg: {
    primary: '#404040',
    secondary: darkThemeColors.base600,
    overlay: '#000',
    productCompare: darkThemeColors.yellove500,
    productCompareLight: setRgbaAlpha(darkThemeColors.yellove500, '0.05'),
  },
  header: {
    bg: darkThemeColors.maybeBlue500,
    fg: darkThemeColors.base100,
  },
  footer: {
    bg: {
      primary: darkThemeColors.base100,
      secondary: darkThemeColors.base100,
    },
    fg: {
      primary: darkThemeColors.base600,
    },
  },
  text: {
    primary: 'white',
    secondary: '#eee',
    tertiary: '#bbb',
    quaternary: '#aaa',
    linkExternal: darkThemeColors.maybeBlue700,
    linkExternalHover: darkThemeColors.maybeBlue500,
    linkInternal: darkThemeColors.base0,
    linkInternalHover: darkThemeColors.base0,
    callToAction: darkThemeColors.maybeBlue700,
    callToActionHover: darkThemeColors.maybeBlue500,
    negative: darkThemeColors.negative700,
    positive: darkThemeColors.positive500,
  },
  icons: {
    primary: darkThemeColors.base600,
    secondary: darkThemeColors.base500,
    tertiary: darkThemeColors.base400,
    quaternary: darkThemeColors.base300,
    light: darkThemeColors.base500,
    callToAction: darkThemeColors.maybeBlue700,
    callToActionHover: darkThemeColors.maybeBlue500,
    positive: darkThemeColors.positive300,
    negative: darkThemeColors.negative700,
  },
  lines: {
    primary: '#303030',
    secondary: '#202020',
    tertiary: '#101010',
    quaternary: '#000',
    highlight: darkThemeColors.maybeBlue700,
    groupHeader: darkThemeColors.yellove500,
  },
  buttons: {
    primary: {
      bg: darkThemeColors.maybeBlue700,
      bgActive: darkThemeColors.maybeBlue100,
      text: darkThemeColors.base0,
      textHover: darkThemeColors.base0,
    },
    secondary: {
      bg: darkThemeColors.base500,
      text: darkThemeColors.base0,
      textHover: darkThemeColors.base0,
    },
    tertiary: {
      bg: darkThemeColors.base600,
      text: darkThemeColors.base0,
      textHover: darkThemeColors.base0,
    },
    quarternary: {
      bg: darkThemeColors.base700,
      text: darkThemeColors.base0,
      textHover: darkThemeColors.base0,
    },
    positive: {
      bg: darkThemeColors.positive700,
      text: darkThemeColors.base0,
      textHover: darkThemeColors.base0,
    },
    negative: {
      bg: darkThemeColors.negative700,
      text: darkThemeColors.base0,
      textHover: darkThemeColors.base0,
    },
    link: {
      bg: 'transparent',
      text: darkThemeColors.maybeBlue700,
      textHover: darkThemeColors.maybeBlue500,
    },
    disabled: {
      bg: darkThemeColors.base500,
      text: darkThemeColors.base0,
      textHover: darkThemeColors.base0,
    },
    category: {
      bg: '#404040',
      bgActive: darkThemeColors.base600,
      text: darkThemeColors.base0,
      textHover: darkThemeColors.base100,
    },
    panning: {
      bg: 'rgba(0, 0, 0, 0.6)',
      bgHover: 'rgba(0, 0, 0, 0.4)',
      text: darkThemeColors.base0,
    },
  },
  pill: {
    primary: {
      bg: darkThemeColors.maybeBlue700,
      text: darkThemeColors.base0,
    },
    inverted: {
      bg: darkThemeColors.base0,
      text: darkThemeColors.base700,
    },
  },
  inputs: {
    primary: {
      bg: darkThemeColors.base0,
      border: darkThemeColors.base500,
      borderFocus: darkThemeColors.maybeBlue700,
    },
  },
  dropdowns: {
    primary: {
      bg: darkThemeColors.base0,
      hoverBackground: setRgbaAlpha(darkThemeColors.maybeBlue700, '0.2'),
      borderRadius: '5px',
      borderColor: {
        active: darkThemeColors.base700,
        inactive: darkThemeColors.base700,
      },
    },
    secondary: {
      bg: darkThemeColors.base0,
      hoverBackground: setRgbaAlpha(darkThemeColors.maybeBlue700, '0.2'),
      borderRadius: 0,
      borderColor: {
        active: darkThemeColors.base200,
        inactive: 'transparent',
      },
    },
  },
  placeholders: {
    bg: darkThemeColors.base100,
    fg: darkThemeColors.base300,
  },
  cookieBanner: {
    bg: setRgbaAlpha(darkThemeColors.base700, '0.9'),
    fg: darkThemeColors.base0,
  },
  actionBar: {
    bg: darkThemeColors.base700,
    fg: darkThemeColors.base0,
    boxShadow: '0 -2px 10px 0 rgba(0, 0, 0, 0.2)',
  },
  ratings: {
    positive: {
      bg: darkThemeColors.positive300,
      fg: darkThemeColors.positive700,
    },
    neutral: { bg: darkThemeColors.notice300, fg: darkThemeColors.yellove900 },
    negative: {
      bg: darkThemeColors.negative300,
      fg: darkThemeColors.negative700,
    },
    disabled: { bg: darkThemeColors.base200, fg: darkThemeColors.base500 },
  },
  notifications: {
    info: {
      bg: setRgbaAlpha(darkThemeColors.maybeBlue700, '0.04'),
      fg: darkThemeColors.maybeBlue700,
    },
    issue: {
      bg: setRgbaAlpha(darkThemeColors.negative300, '0.2'),
      fg: setRgbaAlpha(darkThemeColors.negative700, '0.7'),
    },
    neutral: {
      bg: darkThemeColors.base100,
      fg: darkThemeColors.base600,
    },
  },
  promos: {
    bg: darkThemeColors.maybeBlue100,
    fg: darkThemeColors.base600,
  },
};

export default darkTheme;
